import { combineReducers } from '@reduxjs/toolkit';
import checkoutSlice from "./reducers/checkoutSlice"
import navigationSlice from "./reducers/navigationSlice"

const rootReducer = combineReducers({
  checkout: checkoutSlice,
  navigation: navigationSlice
});

export default rootReducer;